module.exports = __webpack_public_path__ + "3bcd78754df9eb7f8482adfdf2de3b0c.svg";